import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import DownloadwithDisplayProper from "../../../../Common/FilesRelevent/DownloadwithDisplayProper";
import { Tooltip } from "react-tooltip";
import {
  formatNumberWithCommas,
  getMemberSince,
} from "../../../../Common/AllDateTimeReleventFormate";
import CustomeMilestone from "../../../../Common/CustomeLabel/CustomeMilestone";
import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import { penaltytips } from "../../../../Common/Tooltips/tooltip";

export default function ManageAppliedProjectProposal({ pd }) {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const path = "Assets/scss/FindWork.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, []);

  return (
    <div className="project-details project-section p-0">
      <div className="post-details">
        <div className="proposal-left">
          <img src={pd?.profile_image ? pd?.profile_image : ProfilePic} alt="" width={30} height={30} />
          <div>
            <h5>
              {pd?.first_name} {pd?.last_name}
              <span>
                <i className="fa-solid fa-star"></i> {pd?.expert_rating || 0} (
                {pd?.expert_comment_count || 0} reviews)
              </span>
            </h5>
            <p>{pd?.designation}</p>
            {/* <h6>
              {pd?.price_per_hour == 0
                ? ``
                : `$ ${formatNumberWithCommas(pd?.price_per_hour)}/hr`} {" "}
              {pd?.price_per_month == 0
                ? ``
                : `$ ${formatNumberWithCommas(pd?.price_per_month)}/month`}
            </h6> */}
          </div>
        </div>
        <div className="lang-sec">
          <h4>Proposal Details</h4>
          <h6>Cover letter</h6>
          <CustomReactQuillDescription value={pd?.message} displyreadorless={true} key={pd?.id} />

        </div>
        <div className="dollar-sec lang-sec mt-0 col-md-4 justify-content-between" >
          <div>
            <h6>Propose price</h6>
            <h4 className="mb-0">
              {/* <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
                alt=""
              />
              Budget: */}
              $ {formatNumberWithCommas(pd?.price)}
            </h4>
          </div>
          <div>
            <h6>Project duration</h6>
            <h4 className="mb-0">
              {pd?.type == 2 ? (
                <> {getMemberSince(pd?.last_date)} </>
              ) : (
                <>
                  {pd?.duration}&nbsp;
                  {pd?.duration_type == 2
                    ? "Days"
                    : pd?.duration_type == 3
                      ? "Weeks"
                      : pd?.duration_type == 4
                        ? "Months"
                        : ""}
                </>
              )}
            </h4>
          </div>
        </div>
        {/* <p>
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
            alt=""
          />
        </p> */}
        <div className="lang-sec">
          <h6>Competencies</h6>
          <div className="photoshop">
            {Array.isArray(pd?.skills) &&
              pd?.skills.map((item1, index1) => (
                <p key={index1}>{item1.title}</p>
              ))}
          </div>
        </div>
        <CustomeMilestone milestones={pd?.milestones} />

        {pd?.files?.length > 0 && Array.isArray(pd?.files) && (
          <div className="lang-sec">
            <h6>Attachments</h6>
            <div className="images">
              {pd?.files.map((item, index) => (
                <DownloadwithDisplayProper item={item} />
              ))}
            </div>
          </div>
        )}
      </div>

      <Tooltip
        id="my-tooltip-1"
        place="bottom"
        content={penaltytips}
      />
    </div>
  );
}
